export enum Category {
  Pc = "pc",
  Smartphone = "smartphone",
  Mobilephone = "mobilephone",
  Appliance = "appliance",
  Crawler = "crawler",
  Misc = "misc",
  Unknown = "UNKNOWN",
}
